import { useEffect } from 'react';
import { useClickTracking } from '@rmc/webcx-web-libs';

type DefaultContentTrackerPropsType = {
	portalContainer: HTMLElement;
	onRendered?: () => void;
	onLinkClick?: (url: string) => Promise<unknown>;
};

export function DefaultContentTracker({
	portalContainer,
	onRendered = () => {},
	onLinkClick = () => Promise.resolve(null),
}: DefaultContentTrackerPropsType) {
	useEffect(() => {
		onRendered();
	}, []);

	useClickTracking({ current: portalContainer }, onLinkClick);

	return null;
}
